export const DeleteIcon = ({
  className,
  strokeWidth = 1,
}: {
  className?: string
  strokeWidth?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        d="M14 3.98568C11.78 3.76568 9.54668 3.65234 7.32001 3.65234C6.00001 3.65234 4.68 3.71901 3.36 3.85234L2 3.98568"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66797 3.31203L5.81464 2.4387C5.9213 1.80537 6.0013 1.33203 7.12797 1.33203H8.87464C10.0013 1.33203 10.088 1.83203 10.188 2.44537L10.3346 3.31203"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5669 6.09375L12.1336 12.8071C12.0603 13.8538 12.0003 14.6671 10.1403 14.6671H5.86026C4.00026 14.6671 3.94026 13.8538 3.86693 12.8071L3.43359 6.09375"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.88672 11H9.10672"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33203 8.33203H9.66537"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
